export default __webpack_public_path__ + "static/alertive-6607c5753e8277bfaa26597c1cf35e92.svg";